// Model.js
// -----------------------
// @module Case
define("NVT.EventCalendarExt.MyEventModule.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MyEventModule/SuiteScript2/MyEventModule.Service.ss"
            ),
            true
        )
});
});
